import React from 'react'
import { Form } from 'react-bootstrap'

export default function SurveyForm({ survey, register, errors }) {
	return (
		<React.Fragment>
			<Form.Group>
				<Form.Label>Nombre encuesta <span className="text-danger">*</span></Form.Label>
				<Form.Control 
					{...register("name", {required: true})} 
					defaultValue={survey && survey.name} 
				/>
				{ errors.name && <Form.Text className="text-warning">Este campo es requerido.</Form.Text> }
			</Form.Group>
			<Form.Group>
				<Form.Label>Estado</Form.Label>
				<Form.Control as="select" {...register('active',{required:true})} defaultValue={survey && survey.active}>
					<option value="1">Activa</option>
					<option value="0">Inactiva</option>
				</Form.Control>
			</Form.Group>
		</React.Fragment>
	)
}